import _babel from '@babel/polyfill/noConflict'
import SiteInstance from 'sitekit'

// Create new site
const Site = new SiteInstance()

// Install globals for dev purposes
window.Site = Site
const $ = (window.$ = Site.$)

// stop preload
Site.preloadPages = () => {}

Site.xhrOptions.swapContent = (container, originalContent, newContent) => {
  newContent.css({
    opacity: 0,
    display: '',
    position: 'absolute',
    width: '100%'
  })
  originalContent
    .css({
      opacity: 1
    })
    .transition({
      opacity: 0,
      duration: 300,
      complete: () => {
        originalContent.remove()
        newContent.css({ position: '' })
        newContent.transition({
          opacity: 1,
          duration: 300,
          complete: () => {
            newContent.css({ opacity: '' })
          }
        })
      }
    })

  container.append(newContent)

  return 200
}

// Run widget functions
const autoInclude = require.context('./widgets', false, /.js$/)
autoInclude.keys().forEach(id => {
  const module = autoInclude(id)
  const call = module.default ? module.default : module
  if (typeof call === 'function') {
    call(Site, Site.$)
  }
})

if (/wp-admin/.test(window.location.href)) {
  $.ready(() => {
    $('.edit-post-visual-editor')
  })
}